<template>
    <div>
        <DFormRow
            :label="__('products.productPrices.form.discount_name')"
            :error="errors.discount_name"
        >
            <DInput
                :id="`discount_name${idSuffix}`"
                :model-value="discountName"
                maxlength="64"
                @update:modelValue="$emit('update:discountName', $event)"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.productPrices.form.discount')"
            :error="errors.discount_value"
        >
            <DInput
                :id="`discount_value${idSuffix}`"
                :model-value="discountValue"
                @update:modelValue="$emit('update:discountValue', $event)"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.productPrices.form.discount_type')"
            :error="errors.discount_type"
        >
            <DSelect
                :id="`discount_type${idSuffix}`"
                :model-value="discountType"
                :options="discountTypes"
                @update:modelValue="$emit('update:discountType', $event)"
            />
        </DFormRow>
    </div>
</template>

<script>
export default {
    name: 'Discount',
    props: {
        discountName: {
            type: [String, Number],
            default: null
        },
        discountValue: {
            type: [String, Number],
            default: null
        },
        discountType: {
            type: [String, Number],
            default: null
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        discountTypes: {
            type: Array,
            default: () => { return [] }
        },
        idSuffix: {
            type: String,
            default: ''
        }
    },
    emits: ['update:discountName', 'update:discountValue', 'update:discountType']
}
</script>
